
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_758_9333)"}},[_c('path',{attrs:{"d":"M12.5 4.4a.9.9 0 11-1.8 0 .9.9 0 011.8 0z"}}),_c('path',{attrs:{"d":"M10.25.8A4.906 4.906 0 005.3 5.75c0 .357.036.716.11 1.058.052.243-.007.453-.128.574l-4.086 4.086a1.35 1.35 0 00-.396.956v1.426a1.35 1.35 0 001.35 1.35h1.8a1.35 1.35 0 001.35-1.35v-.45h.9a.9.9 0 00.9-.9v-.9H8a.9.9 0 00.9-.9v-.162c.444.12.906.162 1.35.162a4.906 4.906 0 004.95-4.95A4.906 4.906 0 0010.25.8zM6.2 5.75c0-2.272 1.778-4.05 4.05-4.05s4.05 1.778 4.05 4.05-1.778 4.05-4.05 4.05c-.594 0-1.146-.086-1.598-.312A.45.45 0 008 9.89v.81h-.9a.9.9 0 00-.9.9v.9h-.9a.9.9 0 00-.9.9v.45a.45.45 0 01-.45.45h-1.8a.45.45 0 01-.45-.45v-1.427a.45.45 0 01.131-.318l4.087-4.087c.39-.389.47-.94.371-1.4A4.157 4.157 0 016.2 5.75z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_758_9333"}},[_c('path',{attrs:{"transform":"translate(.8 .8)","d":"M0 0h14.4v14.4H0z"}})])])])
          )
        }
      }
    